import { allThemeConfigs, allThemeRoutes } from "#/.contentlayer/generated";

// getThemeConfig
export function getThemeConfig(theme: string) {
  const configs = allThemeConfigs;
  const config = configs.filter(item => item.name === theme);

  return config;
}

// getThemeConfig
export function getThemeRoute(theme: string) {
  const routes = allThemeRoutes;
  const route = routes.filter(item => item._raw.sourceFileName.includes(theme));

  return route;
}
